import { render, staticRenderFns } from "./SearchAmendmentResultTable.vue?vue&type=template&id=c914bbe0&scoped=true&"
import script from "./SearchAmendmentResultTable.vue?vue&type=script&lang=ts&"
export * from "./SearchAmendmentResultTable.vue?vue&type=script&lang=ts&"
import style0 from "./SearchAmendmentResultTable.vue?vue&type=style&index=0&id=c914bbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c914bbe0",
  null
  
)

export default component.exports